import api from '../../utils/api';
import { ADMIN_CHECKOUTS } from '../../constants/routes';
import {
  AdminCheckoutListParams,
  AdminCheckoutListResponse,
} from '../../types/adminCheckout';

type ApiResult<T> = { data: T | null; status: number; error?: string };

function parseApiError(error: unknown, fallback: string): ApiResult<never> {
  const err = error as { response?: { status?: number; data?: { detail?: string; message?: string } } };
  const status = err.response?.status ?? 500;
  const detail = err.response?.data?.detail ?? err.response?.data?.message;
  return {
    data: null,
    status,
    error: typeof detail === 'string' ? detail : fallback,
  };
}

export async function fetchAdminCheckouts(
  params: AdminCheckoutListParams = {}
): Promise<ApiResult<AdminCheckoutListResponse>> {
  try {
    const query: Record<string, string | number> = {
      limit: params.limit ?? 10,
      offset: params.offset ?? 0,
    };
    if (params.search?.trim()) query.search = params.search.trim();

    const sport = params.sport_code?.trim();
    const conference = params.conference_name?.trim();
    if (sport) query.sport_code = sport;
    if (conference) query.conference_name = conference;

    const response = await api.get<AdminCheckoutListResponse>(ADMIN_CHECKOUTS, { params: query });
    return { data: response.data, status: response.status };
  } catch (error: unknown) {
    return parseApiError(error, 'Failed to load checkouts');
  }
}
